import "./ModalComponent.css";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";

import React, { useState } from "react";

import DatePicker from "react-date-picker";
import Select from "react-select";
import UploadImageIcon from "../../../assets/UploadImageIcon";
import { customStyles } from "./MultiSelectStyle";
import moment from "moment";
import { useTranslation } from "react-i18next";

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import DatePickerComponent from "../DatePickerComponent/DatePickerComponent";

const ModalComponent = ({
    isOpen,
    onClose,
    fieldsData,
    onChangeInput,
    buttons,
    modalTitle,
    inputType,
    formData,
    onChangeDate,
    onChangeImage,
    preview,
    onChangeMultiselect,
    modalType,
    modalName,
}) => {
    const [selectedFile, setSelectedFile] = useState("");
    const { t, i18n } = useTranslation();

    if (!isOpen) return null;
    // const [selectedDate, setSelectedDate] = useState(null);
    const handelChangeInput = (e, field) => {
        const selectedIndex = e.target.selectedIndex;
        if (field === "dropdown") {
            const label = e.target.options[selectedIndex].text;
            onChangeInput(e.target, label);
        } else {
            onChangeInput(e.target);
        }
    };

    const handleDateChange = (date, name) => {
        // setSelectedDate(date);
        onChangeDate(date, name);
    };

    const handleChangeMultiSelect = (selected, label) => {
        onChangeMultiselect(selected, label);
    };

    const handleFileChange = (event, rowIndex) => {
        const file = event.target.files[0];
        let url = URL.createObjectURL(file);
        setSelectedFile(file);
        onChangeImage(event, url, file);
    };

    const handleClick = () => {
        document.getElementById("fileInput").click();
    };

    const getMinDate = (item) => {
        if (item.name === "startDate") {
            return new Date();
        } else if (item.name === "endDate") {
            if (modalType === "add" || modalType === "edit")
                return new Date(formData?.startDate);
            else {
                return null;
            }
        }
    };

    const getCustomOptions = (options) => {
        return [{ value: "all", label: "All" }, ...options];
    };

    return (
        <div className={["modal", "overlayStyle"].join(" ")}>
            <div className="modalStyle">
                <div className="modalHeader">
                    <span className="modalTitle">{modalTitle}</span>
                    <button onClick={onClose} className="closeButtonStyle">
                        X
                    </button>
                </div>

                <div className="outerWrapper">
                    {fieldsData?.map((item, index) => {
                        return (
                            <div className="fieldsOuterDiv">
                                <div className="fieldName">
                                    {item.fieldName}
                                    <span className="requiredText">
                                        {item.required === true && "*"}
                                    </span>
                                    :
                                </div>
                                {item.type === "multiInput" && (
                                    <div className="multiInputContainer">
                                        {item.fields.map((field, idx) => (
                                            <div key={idx} className="multiInputField">
                                                <span className="multiInputLabel">{field.label}</span>
                                                <input
                                                    name={field.name}
                                                    onChange={(e) => handelChangeInput(e, "input")}
                                                    type="text"
                                                    value={formData[field.name]}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {item.type === "input" && (
                                    <input
                                        name={item.name}
                                        onChange={(e) =>
                                            handelChangeInput(e, item.type)
                                        }
                                        type={item.inputType}
                                        value={formData[item.name]}
                                        disabled={
                                            item?.isDisabled &&
                                            modalType === "edit"
                                        }
                                        className="inputField"
                                    />
                                )}
                                {item.type === "dropdown" && (
                                    <select
                                        value={formData[item.name]}
                                        onChange={(e) =>
                                            handelChangeInput(e, item.type)
                                        }
                                        name={item.name}
                                        disabled={
                                            (item?.isDisabled &&
                                                modalType === "edit" &&
                                                modalName === "level") ||
                                            item?.isFieldDisabled
                                        }
                                        className="inputField select-dropdown"
                                    >
                                        {item.name === "roles" && (
                                            <option value="" disabled selected>
                                                {t("selectRole")}
                                            </option>
                                        )}
                                        {item.name === "sector" && (
                                            <option value="" disabled selected>
                                                {t("selectSector")}
                                            </option>
                                        )}
                                        {item.name === "bu" && (
                                            <option value="" disabled selected>
                                                {t("selectBU")}
                                            </option>
                                        )}
                                        {item.name === "subBU" && (
                                            <option value="" selected>
                                                {t("selectSubBU")}
                                            </option>
                                        )}
                                        {item.name === "regionName" && (
                                            <option value="" disabled selected>
                                                {t("selectRegion")}
                                            </option>
                                        )}
                                        {item.name === "legalEntity" && (
                                            <option value="" selected>
                                                {t("selectEntity")}
                                            </option>
                                        )}
                                        {item?.options?.map((option, index) => (
                                            <option
                                                key={index}
                                                value={option.value}
                                            >
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                )}
                                {item.type === "multiselect" && (
                                    <>
                                        <Select
                                            isMulti
                                            options={getCustomOptions(
                                                item?.options
                                            )}
                                            value={formData[item.name]}
                                            onChange={(selectedOptions) => {
                                                if (
                                                    selectedOptions.some(
                                                        (option) =>
                                                            option.value ===
                                                            "all"
                                                    )
                                                ) {
                                                    handleChangeMultiSelect(
                                                        item?.options,
                                                        item.name
                                                    );
                                                } else {
                                                    handleChangeMultiSelect(
                                                        selectedOptions,
                                                        item.name
                                                    );
                                                }
                                            }}
                                            isDisabled={item?.isFieldDisabled}
                                            styles={customStyles}
                                            className="inputField"
                                            placeholder={t("selectCountry")}
                                            closeMenuOnSelect={false} // Keeps the menu open while selecting options
                                        />
                                    </>
                                )}
                                {item.type === "datepicker" && (
                                    // <DatePickerComponent />
                                    // <DatePicker
                                    //     selected={formData[item.name]}
                                    //     onChange={(date) => handleDateChange(date, item.name)}
                                    //     dateFormat="MM/dd/yyyy"
                                    //     placeholderText="mm/dd/yyyy"
                                    //     // isClearable
                                    //     name={item.name}
                                    //     // showMonthDropdown
                                    //     // showYearDropdown
                                    //     // scrollableYearDropdown
                                    // />
                                    <>
                                        <DatePicker
                                            onChange={(date) =>
                                                handleDateChange(
                                                    date,
                                                    item.name
                                                )
                                            }
                                            value={
                                                formData[item.name]
                                                    ? moment(
                                                        formData[item.name]
                                                    ).format("DD/MMM/YYYY")
                                                    : null
                                            }
                                            format="dd/MM/yyyy"
                                            monthPlaceholder="mm"
                                            dayPlaceholder="dd"
                                            yearPlaceholder="yyyy"
                                            disabled={
                                                (modalType === "edit" &&
                                                    item.name ===
                                                    "startDate") ||
                                                (modalType === "add" &&
                                                    item.name === "endDate" &&
                                                    formData["startDate"] ===
                                                    "")
                                            }
                                            className={
                                                modalType === "add" &&
                                                    item.name === "startDate"
                                                    ? "datepicker"
                                                    : ""
                                            }
                                            minDate={getMinDate(item)} // disables all past dates
                                        />
                                    </>
                                )}

                                {item.type === "textarea" && (
                                    <textarea
                                        name={item.name}
                                        onChange={(e) =>
                                            handelChangeInput(e, item.type)
                                        }
                                        type="text"
                                        value={formData[item.name]}
                                        rows="3"
                                        className="inputField"
                                    />
                                )}

                                {item.type === "image" && (
                                    <>
                                        <input
                                            type="file"
                                            id="fileInput"
                                            style={{ display: "none" }}
                                            onChange={(e) =>
                                                handleFileChange(e, index)
                                            }
                                            className="inputField"
                                        />
                                        <div
                                            style={{ cursor: "pointer" }}
                                            onClick={handleClick}
                                        >
                                            {preview !== "" &&
                                                preview
                                                    ?.toString()
                                                    .includes("blob") ? (
                                                <img
                                                    src={preview}
                                                    alt={t("uploadedFile")}
                                                    className="imgStyle"
                                                />
                                            ) : (
                                                <UploadImageIcon />
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        );
                    })}

                    <div className="buttonsOuterDiv">
                        {buttons &&
                            buttons.map((button, index) => (
                                <span key={index}>{button}</span>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalComponent;
